import axiosInstance, { getApiUrl, ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { getFileDownload } from '@cp/src/utils/commonUtils';

export const fetchOriginalFile = (referenceId: string) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_ALLOCATION_ORIGINAL_FILE, { referenceId: referenceId });
  axiosInstance
    .get(url)
    .then(res => {
      getFileDownload(res?.data);
    })
    .catch(err => {
      logError(err);
    });
};

export const fetchFailureReport = (fileReferenceId: string) => {
  const url = getApiUrl(ApiKeys.GET_ALLOCATION_FAILURE_REPORT, { referenceId: fileReferenceId });
  return axiosInstance
    .get(url)
    .then(response => {
      getFileDownload(response?.data);
    })
    .catch(err => {
      logError(err);
    });
};

export const fetchUploadHistoryPolling = (pageNo: number, pageSize: number, type?: string) => {
  const url = getApiUrl(
    ApiKeys.GET_REALLOCATION_HISTORY,
    {},
    {
      pageNo: pageNo,
      pageSize: pageSize,
      requestSubType: type || ''
    }
  );
  return axiosInstance.get(url);
};
